import { TYPE_MOVITEL_ERROR_CODE, TYPE_MOVITEL_MAGICWHEEL, TYPE_MOVITEL_VM, TYPE_MOVITEL_REVENUE } from "./type";

const initialState = {
  revenue: [],
};

export const reducerMovitel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MOVITEL_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerMovitelErrorCode = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MOVITEL_ERROR_CODE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerMovitelVm = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MOVITEL_VM:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};
export const reducerMagicWheel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MOVITEL_MAGICWHEEL:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};
